module.exports = __webpack_public_path__ + "img/SlideShow06.75465732.jpg";